import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { WidgetWrapper } from '../../layout';
import { jsx as _jsx } from "react/jsx-runtime";
export const Error = ({
  children
}) => /*#__PURE__*/_jsx(WidgetWrapper, {
  children: /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest",
    children: /*#__PURE__*/_jsx("p", {
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "common.error"
      })
    })
  })
});